export default "__VITE_ASSET__BNPb0N85__"